import { render, staticRenderFns } from "./SubTable.vue?vue&type=template&id=3a5e8faf&"
import script from "./SubTable.vue?vue&type=script&lang=js&"
export * from "./SubTable.vue?vue&type=script&lang=js&"
import style0 from "./SubTable.vue?vue&type=style&index=0&id=3a5e8faf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports